import { useCallback, useEffect, useState } from "react";
import Icon from "@mui/material/Icon";
import axios from "axios";
import { API_URL } from "config";

const badgeStyle = {
  position: "absolute",
  top: -8,
  right: -10,
  minWidth: 17,
  height: 17,
  padding: "0 5px",
  borderRadius: 999,
  background: "#ef4444",
  color: "#fff",
  fontSize: 10,
  fontWeight: 700,
  lineHeight: "17px",
  textAlign: "center",
};

const BidNotificationBadgeIcon = () => {
  const [count, setCount] = useState(0);

  const fetchCount = useCallback(async () => {
    const token = localStorage.getItem("authToken");
    if (!token) {
      setCount(0);
      return;
    }

    try {
      const { data } = await axios.get(`${API_URL}/notifications/counts?module=bids`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setCount(Number(data?.unread_counts?.modules?.bids || 0));
    } catch {
      setCount(0);
    }
  }, []);

  useEffect(() => {
    fetchCount();
    const countsUpdatedHandler = (event) => {
      const payload = event.detail || {};
      const counts = payload.counts || payload;

      if (counts?.modules) {
        setCount(Number(counts.modules.bids || 0));
      }
    };
    const echoHandler = (event) => {
      const meta = event.detail?.meta || {};
      const moduleName = meta.module || event.detail?.module;

      if (moduleName === "bids") {
        setCount((current) => current + 1);
      }
    };

    window.addEventListener("notification-counts-updated", countsUpdatedHandler);
    window.addEventListener("echo-event", echoHandler);

    return () => {
      window.removeEventListener("notification-counts-updated", countsUpdatedHandler);
      window.removeEventListener("echo-event", echoHandler);
    };
  }, [fetchCount]);

  return (
    <span style={{ position: "relative", display: "inline-flex" }}>
      <Icon>assignment</Icon>
      {count > 0 && <span style={badgeStyle}>{count}</span>}
    </span>
  );
};

export default BidNotificationBadgeIcon;
